import React from "react";

export type PinterestLogoProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 15,
    height: 15,
  },
  medium: {
    width: 24,
    height: 24,
  },
  large: {
    width: 60,
    height: 60,
  },
};

export const PinterestLogo = React.forwardRef<
  SVGSVGElement,
  PinterestLogoProps
>((props, ref) => {
  const { size = "medium", width, height, color = "black" } = props;
  const svgSize = width && height ? { width, height } : sizes[size];

  return (
    <svg
      ref={ref}
      width={svgSize.width}
      height={svgSize.height}
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0C6.75 0 0 6.75 0 15C0 21.375 4 26.75 9.5 29C9.375 27.875 9.25 26 9.5 24.75C9.75 23.625 11.25 17.25 11.25 17.25C11.25 17.25 10.875 16.25 10.875 15C10.875 12.875 12.125 11.375 13.625 11.375C14.875 11.375 15.5 12.375 15.5 13.5C15.5 14.75 14.625 16.75 14.25 18.5C13.875 20 15 21.25 16.5 21.25C19.125 21.25 21.25 18.5 21.25 14.375C21.25 10.75 18.625 8.25 15 8.25C10.75 8.25 8.25 11.5 8.25 14.75C8.25 16 8.75 17.375 9.375 18.125C9.5 18.25 9.5 18.375 9.5 18.5C9.375 19 9.125 20 9.125 20.25C9 20.5 8.875 20.625 8.625 20.5C6.75 19.625 5.625 16.875 5.625 14.75C5.625 10 9.125 5.625 15.5 5.625C20.75 5.625 24.75 9.375 24.75 14.25C24.75 19.375 21.5 23.625 17 23.625C15.5 23.625 14 22.875 13.5 21.875C13.5 21.875 12.75 24.75 12.625 25.5C12.25 26.75 11.375 28.375 10.75 29.375C12 29.75 13.5 30 15 30C23.25 30 30 23.25 30 15C30 6.75 23.25 0 15 0Z"
        fill={color}
      />
    </svg>
  );
});

PinterestLogo.displayName = "PinterestLogo";
